import React from 'react';
import Select from 'react-select';
import { Form, Formik } from 'formik';
import { TYPES_OF_ZAKAT } from '../../common/images-svg';
import { selectedStyles } from '../../common';
import NumberFormat from 'react-number-format';
import { ERRORS } from '../../common/errors'
import { connect } from 'react-redux';
import * as zakat from '../../redux/actions/zakatActions';
import { config } from '../../common/constant'
import * as Constants from '../../common/constant';
import { withTranslation } from "react-i18next";

class Type extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.type ? this.props.type : null,
            defaultSelection: this.props.type ? this.props.type.sourceSelected : '',
            isSelected: false,
            isAmtDisabled: false,
            errorExists: false,
            category: this.props.type ? String(this.props.type.name).toLowerCase() : null,
            amount: parseFloat(this.props.zakat[this.props.type.name.toLowerCase()].amount) === 0 ? '' : parseFloat(this.props.zakat[this.props.type.name.toLowerCase()].amount),
            decimalval: false,
            errorRateMSG: '',
            parentObj: this.props.zakat,
            isDropDownDisabled: this.props.user.isBusinessPayer ? true : false,
        }

        this.getType = this.getType.bind(this);
    }

    componentDidMount() {

        if (this.state.category === 'business') {
            this.setState({
                isDropDownDisabled: true,
                sourceSelected: [{
                    "label": "Trade",
                    "value": "Trade"
                }]
            })
        }

        if (this.state.defaultSelection === 'Select') {
            // this.setState({ isAmtDisabled: this.props.user.hasIRASInclusion ? true : false, amount: '' })
        }
    }

    getType(e, setFieldError) {
        let value = e;
        let mainObj = this.props.zakat;
        mainObj[this.state.category].type = value['value'];

        this.setState({ sourceSelected: [value], isAmtDisabled: value.value === 'Select' });

        if (value['value'] !== 'Select' && this.state.amount === '' || this.state.amount === undefined) {
            setFieldError('amount', ERRORS.ENTER_AMOUNT);
            mainObj[this.state.category].amount = 0;
            this.props.updateContext(this.state.errorExists);
        } else if (value['value'] === 'Select') {
            this.setState({ isAmtDisabled: true, amount: '' }, () => {
                setFieldError('amount', "");
                mainObj[this.state.category].amount = 0;
                mainObj[this.state.category].type = null;
                this.props.updateContext(this.state.errorExists);
            })
        } else {
            this.setState({ isAmtDisabled: false, amount: 0 }, () => setFieldError('amount', ERRORS.ENTER_AMOUNT));
            this.props.updateContext(this.state.errorExists);
        }
        this.props.dispatch(zakat.updateZakatData(mainObj))
    }

    setData(amount) {
        let data = { type: this.state.sourceSelected['value'], amount }
        return data;
    }

    totalAmount(category, updatedAmount) {
        let total = 0;
        Object.keys(this.state.parentObj).forEach(val => {
            if (this.props.zakat[val]?.amount && category !== val) {
                total += parseInt(this.props.zakat[val]?.amount);
            } else if (category === val && updatedAmount) {
                total += parseInt(updatedAmount);
            }
        })
        return total
    }

    shouldComponentUpdate(newProps) {
        if (newProps.type.name !== this.props.type.name) {
            this.setState({
                data: newProps.type ? newProps.type : null,
                defaultSelection: newProps.type ? newProps.type.sourceSelected : '',
                category: newProps.type ? String(newProps.type.name).toLowerCase() : null,
                amount: parseFloat(newProps.zakat[newProps.type.name.toLowerCase()].amount) === 0 ? '' : parseFloat(newProps.zakat[newProps.type.name.toLowerCase()].amount),
                parentObj: newProps.zakat,
                isAmtDisabled: newProps.user.hasIRASInclusion ? true : false,
                isDropDownDisabled: newProps.user.isBusinessPayer ? true : false
            });
        }

        if (newProps.user.hasIRASInclusion !== this.props.user.hasIRASInclusion) {
            let initialValues = { sourceOfType: null, amount: null };
            this.setState({
                initialValues, amount: '', sourceSelected: [{
                    "label": newProps.type.name?.toLowerCase() === 'business' ? "Trade" : "Select",
                    "value": newProps.type.name?.toLowerCase() === 'business' ? "Trade" : "Select"
                }],
                isAmtDisabled: newProps.user.hasIRASInclusion ? true : false
            })
        }

        return true;
    }

    componentWillReceiveProps(newProps) {
        if (newProps.user.hasIRASInclusion !== this.props.user.hasIRASInclusion) {
            let initialValues = { sourceOfType: null, amount: null };
            this.setState({
                initialValues, amount: '', sourceSelected: [{
                    "label": this.state.category === 'business' ? "Trade" : "Select",
                    "value": this.state.category === 'business' ? "Trade" : "Select"
                }],
                isAmtDisabled: newProps.user.hasIRASInclusion ? true : false
            })
        }
    }

    render() {
        const {t} = this.props;

        let name = "";
        
        // eslint-disable-next-line default-case
        switch(true) {

            case String(this.state.data?.name).includes('Savings'):
                name = t('Savings_label')
                break;

            case String(this.state.data?.name).includes('Gold'):
                name = t('Gold_label')
                break;

            case String(this.state.data?.name).includes('Insurance'):
                name = t('Insurance_label')
                break;

            case String(this.state.data?.name).includes('Shares'):
                name = t('Shares_label')
                break;
        
            case String(this.state.data?.name).includes('Business'):
                name = t('Business_label')
                break;
                
        }

        return (
            <>
                {this.state.data ?
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            sourceOfType: this.state.sourceSelected,
                            amount: this.state.amount
                        }}
                        validateOnBlur={true}
                        validateOnChange={true}
                    >
                        {({ errors, touched, isValid, dirty, setFieldError, setFieldValue, handleReset, resetForm }) => (
                            <Form className="form">
                                <div className='row row-type row-type-harta'>
                                    {/* <div className='col-xs-1 c-icon'>
                                        {TYPES_OF_ZAKAT[this.state.data.name.trim().replace(/\s+/g, '_').toLowerCase()]}
                                    </div> */}
                                    <div className='col-md-6 col-sm-6 col-xs-6 c-type-zakat'>
                                      <h4>  {name}</h4>
                                    </div>
                                    <div className='col-md-6 col-sm-6 col-xs-6 form-group c-amt mb-0'>
                                        {/* <label>{t('Amount_label')}</label>  */}
                                        <NumberFormat
                                            placeholder='$0.00'
                                            inputMode="decimal"
                                            maxLength={11}
                                            getInputRef={this.props.inputRef} // Assign input DOM to ref
                                            onKeyDown={(e) => {
                                              if (e.key === 'ArrowRight') {
                                                const nextRef = this.props.nextInputRef?.();
                                                if (nextRef) nextRef.focus(); // Focus next input field
                                              }
                                            }}
                                            decimalSeparator={'.'}
                                            decimalScale={2}
                                            allowNegative={false}
                                            name='amount'
                                            id={`amount-${this.state.category}`}
                                            className={"disabledField amountsrow form-control " + (errors.amount ? 'is-invalid' : '')}
                                            value={this.props.zakat[this.state.category].amount == 0 ? "" : this.props.zakat[this.state.category].amount}
                                            displayType={'input'}
                                            thousandSeparator={true}
                                            prefix={'$'}
                                            onFocus={() => this.props.shouldDisableField(true)}
                                            isAllowed={({ floatValue }) =>
                                                floatValue === undefined ||
                                                floatValue <= Constants.MAX_OXPAY_ACCEPTANCE_AMOUNT
                                            }
                                            onValueChange={(amount) => {
                                                let mainObj = this.props.zakat;

                                                this.setState({ amount: amount.floatValue })

                                                if (amount.value <= 0.00 || amount.value <= 0) {
                                                    setFieldError('amount', ERRORS.ENTER_AMOUNT)
                                                    mainObj[this.state.category].amount = amount.value
                                                } else if (amount.value < config.DONATION_MIN_AMOUNT) {
                                                    setFieldError('amount', ERRORS.MIN_AMOUNT);
                                                    mainObj[this.state.category].amount = amount.value
                                                } else if (!amount.value) {
                                                    setFieldError('amount', ERRORS.MIN_AMOUNT)
                                                } else {
                                                    setFieldError('amount', '')
                                                    mainObj[this.state.category].amount = amount.value ?? 0;
                                                }
                                                if (mainObj[this.state.category].type === null && this.state.sourceSelected[0].label !== 'Select') {
                                                    mainObj[this.state.category].type = this.state.sourceSelected[0].label
                                                }

                                                this.props.dispatch(zakat.updateZakatData(mainObj))
                                                setTimeout(() => this.props.updateContext(Boolean(errors.amount)), 10);
                                            }}

                                        />
                                        {errors.amount ? <span className="invalid-feedback error">{errors.amount}</span> : null}
                                    </div>
                                </div>
                            </Form>)}
                    </Formik>
                    : null
                }
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        zakat: state.zakatReducer,
        user: state.userReducer
    }
}

export default connect(mapStateToProps)(withTranslation()(Type));